function calulateRate(zone, weight) {
    var fee = 0;console.log(zone);
    weight = ( weight / 1000 ).toFixed(2);console.log(weight);
    if (zone == 1) {
        if (weight <= 0.02) {
            fee =  0;
        } else if (weight > 0.02 && weight <= 0.125) {
            fee =  7;
        } else if (weight > 0.125 && weight <= 0.8) {
            fee = 60;
        } else if (weight > 0.8 && weight <= 1) {
            fee = 65;
        } else if (weight > 1 && weight <= 1.5) {
            fee = 89;
        } else if (weight > 1.5 && weight <= 2) {
            fee = 95;
        } else {
            fee = 30 * (weight - 2)  + 95;
        }
    } else if (zone == 2) {
        if (weight <= 0.02) {
            fee =  0;
        } else if (weight > 0.02 && weight <= 0.125) {
            fee =  7;
        } else if (weight > 0.125 && weight <= 0.8) {
            fee = 75;
        } else if (weight > 0.8 && weight <= 1) {
            fee = 85;
        } else {
            fee = 50 * (weight - 1)  + 85;
        }
    } else if (zone == 3) {
        if (weight <= 0.02) {
            fee =  0;
        } else if (weight > 0.02 && weight <= 0.125) {
            fee =  7;
        } else if (weight > 0.125 && weight <= 0.8) {
            fee = 90;
        } else if (weight > 0.8 && weight <= 1) {
            fee = 105;
        } else {
            fee = 70 * (weight - 1)  + 105;
        }
        /*out of zone*/
    } else if (zone == 4) {
        if (weight <= 0.01) {
            fee =  0;
        } else if (weight > 0.01 && weight <= 0.125) {
            fee =  15;
        } else if (weight > 0.125 && weight <= 0.5) {
            fee = 69;
        } else if (weight > 0.5 && weight <= 0.75) {
            fee = 85;
        } else {
            fee = 60 * (weight - 0.75)  + 85;
        }
    } else if (zone == 5) {
        if (weight <= 0.01) {
            fee =  0;
        } else if (weight > 0.01 && weight <= 0.125) {
            fee =  15;
        } else if (weight > 0.125 && weight <= 0.5) {
            fee = 79;
        } else if (weight > 0.5 && weight <= 0.75) {
            fee = 95;
        } else if (weight > 0.75 && weight <= 1) {
            fee = 114;
        } else {
            fee = 80 * (weight - 1)  + 114;
        }
    } else if (zone == 6) {
        if (weight <= 0.01) {
            fee =  0;
        } else if (weight > 0.01 && weight <= 0.125) {
            fee =  15;
        } else if (weight > 0.125 && weight <= 0.5) {
            fee = 89;
        } else if (weight > 0.5 && weight <= 0.75) {
            fee = 108;
        } else {
            fee = 96 * (weight - 0.75)  + 108;
        }
    } else if (zone == 7) {
        if (weight <= 0.01) {
            fee =  0;
        } else if (weight > 0.01 && weight <= 0.125) {
            fee =  15;
        } else if (weight > 0.125 && weight <= 0.5) {
            fee = 80;
        } else if (weight > 0.5 && weight <= 0.75) {
            fee = 104;
        } else {
            fee = 96 * (weight - 0.75)  + 104;
        }
    } else if (zone == 8) {
        if (weight <= 0.01) {
            fee =  0;
        } else if (weight > 0.01 && weight <= 0.125) {
            fee =  15;
        } else if (weight > 0.125 && weight <= 0.5) {
            fee = 90;
        } else if (weight > 0.5 && weight <= 0.75) {
            fee = 118;
        } else {
            fee = 112 * (weight - 0.75)  + 118;
        }
    } else if (zone == 9) {
        if (weight <= 0.01) {
            fee =  0;
        } else if (weight > 0.01 && weight <= 0.125) {
            fee =  15;
        } else if (weight > 0.125 && weight <= 0.5) {
            fee = 100;
        } else {
            fee = 128 * (weight - 0.5)  + 100;
        }
    } else if (zone == 10) {
        if (weight <= 0.01) {
            fee =  0;
        } else if (weight > 0.01 && weight <= 0.125) {
            fee =  15;
        } else if (weight > 0.125 && weight <= 0.5) {
            fee = 77;
        } else {
            fee = 80 * (weight - 0.5)  + 77;
        }
    } else if (zone == 11) {
        if (weight <= 0.01) {
            fee =  0;
        } else if (weight > 0.01 && weight <= 0.125) {
            fee =  15;
        } else if (weight > 0.125 && weight <= 0.5) {
            fee = 86;
        } else {
            fee = 100 * (weight - 0.5)  + 86;
        }
    } else if (zone == 12) {
        if (weight <= 0.01) {
            fee =  0;
        } else if (weight > 0.01 && weight <= 0.125) {
            fee =  15;
        } else if (weight > 0.125 && weight <= 0.5) {
            fee = 94;
        } else {
            fee = 120 * (weight - 0.5)  + 94;
        }
    } else if (zone == 13) {
        if (weight <= 0.01) {
            fee =  0;
        } else if (weight > 0.01 && weight <= 0.125) {
            fee =  15;
        } else if (weight > 0.125 && weight <= 0.5) {
            fee = 95;
        } else {
            fee = 120 * (weight - 0.5)  + 95;
        }
    } else if (zone == 14) {
        if (weight <= 0.01) {
            fee =  0;
        } else if (weight > 0.01 && weight <= 0.125) {
            fee =  15;
        } else if (weight > 0.125 && weight <= 0.5) {
            fee = 104;
        } else {
            fee = 140 * (weight - 0.5)  + 104;
        }
    } else if (zone == 15) {
        if (weight <= 0.01) {
            fee =  0;
        } else if (weight > 0.01 && weight <= 0.125) {
            fee =  15;
        } else if (weight > 0.125 && weight <= 0.5) {
            fee = 112;
        } else {
            fee = 160 * (weight - 0.5)  + 112;
        }
    } else if (zone == 16) {
        if (weight <= 0.01) {
            fee =  0;
        } else if (weight > 0.01 && weight <= 0.125) {
            fee =  25;
        } else if (weight > 0.125 && weight <= 0.5) {
            fee = 125;
        } else {
            fee = 180 * (weight - 0.5)  + 125;
        }
    } else if (zone == 17) {
        if (weight <= 0.01) {
            fee =  0;
        } else if (weight > 0.01 && weight <= 0.125) {
            fee =  25;
        } else if (weight > 0.125 && weight <= 0.5) {
            fee = 134;
        } else {
            fee = 200 * (weight - 0.5)  + 134;
        }
    } else if (zone == 18) {
        if (weight <= 0.01) {
            fee =  0;
        } else if (weight > 0.01 && weight <= 0.125) {
            fee =  25;
        } else if (weight > 0.125 && weight <= 0.5) {
            fee = 142;
        } else {
            fee = 220 * (weight - 0.5)  + 142;
        }
    } else if (zone == 19) {
        if (weight <= 0.01) {
            fee =  0;
        } else if (weight > 0.01 && weight <= 0.125) {
            fee =  25;
        } else if (weight > 0.125 && weight <= 0.5) {
            fee = 152;
        } else {
            fee = 240 * (weight - 0.5)  + 152;
        }
    } else if (zone == 20) {
        if (weight <= 0.01) {
            fee =  0;
        } else if (weight > 0.01 && weight <= 0.125) {
            fee =  25;
        } else if (weight > 0.125 && weight <= 0.5) {
            fee = 162;
        } else {
            fee = 256 * (weight - 0.5)  + 162;
        }
    } else if (zone == 21) {
        if (weight <= 0.01) {
            fee =  0;
        } else if (weight > 0.01 && weight <= 0.125) {
            fee =  25;
        } else if (weight > 0.125 && weight <= 0.5) {
            fee = 171;
        } else {
            fee = 272 * (weight - 0.5)  + 171;
        }
    } else {
        fee = 'Out of zone';
    }
    if (fee == 0) {
        fee = 'Free';
    }
    return '<table style="width: 100%"><tbody><tr><th style="border: none; padding: 0;color: black;">Estimated delivery fee</th><td style="border: none; padding: 0;color: red;">$' + fee + '</td></tr></tbody></table>';
}